import { z } from 'zod';

import { ComponentValidator, ComponentPayloadValidator } from '../Component';

import { ComponentDefinition } from '../../types/ComponentDefinition';

const SoftwareBase = z.object({
    type: z.literal('software').default('software'),
    electrical: z.object({ ports: z.array(z.never()).default([]) }).default({}),
});

export const SoftwareValidator = ComponentValidator.merge(SoftwareBase);
export const SoftwarePayloadValidator = ComponentPayloadValidator.merge(SoftwareBase);

export const SoftwareDefinition: ComponentDefinition = {
    type: 'software',
    name: 'Software',
    plural: 'Software',
    indicator: 'SW',
    hasDynamicNumberOfPorts: false,
    interoperabilityDataModel: false,
    disableDiagramUse: true,
    description: 'Software and cloud products',
    ports: {
        min: 0,
        max: 0,
        powerFlowDirections: [],
    },
    liveData: {
        enabled: true,
        showGraphs: true,
    },
    validators: {
        component: SoftwareValidator,
        payload: SoftwarePayloadValidator,
    },
};

export type Software = z.infer<typeof SoftwareValidator>;
export type SoftwarePayload = z.infer<typeof SoftwarePayloadValidator>;
